import { PaymentsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const paymentClient = new PaymentsApi(ecomConfiguration)
